import { Loading } from 'element-ui'

let loadingInstance = null

export default {
  show: (text = '加载中...') => {
    loadingInstance = Loading.service({
      lock: true,
      text: text,
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
  },
  hide: () => {
    loadingInstance && loadingInstance.close()
  }
}
